export function formatFullName({
  firstName = '',
  lastName = '',
}: {
  firstName?: string;
  lastName?: string;
}) {
  return `${firstName.trim()} ${lastName.trim()}`.trim();
}
